const ChatSuggestion = ({ onClick, label }) => {
  return (
    <button
      className="bg-gray-100 text-gray-800 pl-1 pr-1 rounded-full border border-solid border-1 border-indigo-600 "
      onClick={onClick}
    >
      <span
        style={{
          fontSize: 11,
        }}
        className="text-[#4394e5] hover:text-[#357abd]"
      >
        {label}
      </span>
    </button>
  );
};

export default ChatSuggestion;
